<template lang="html">
	<section class="contact" v-if="isLandingMounted">
		<router-link :to="{ name: 'Home' }">
			<img class="logo" v-if="displayLogo" :alt="site.title" :src="site.logo_dark"/>
		</router-link>
		<p>{{ $t('questionTag') }} <br> {{ $t('contactAnswer') }} </p>
		<a href="#" @click.prevent="decryptMail('pbagnpg@nynfgn.vb');">contact@alasta.io
			<svg width="28px" height="18px" viewBox="0 0 28 18" version="1.1">
				<title>Arrow</title>
				<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
					<g id="alasta_home" transform="translate(-852.000000, -4742.000000)" stroke="#000000" stroke-width="2">
						<g id="Footer" transform="translate(37.000000, 4437.000000)">
							<g id="Group-6" transform="translate(524.000000, 288.000000)">
								<g id="icn_arrow" transform="translate(292.000000, 18.000000)">
									<line x1="0" y1="7.5" x2="22.2643382" y2="7.5" id="Line-3-Copy"></line>
									<polyline id="Path-9" transform="translate(18.303571, 8.000000) rotate(45.000000) translate(-18.303571, -8.000000) " points="13.3035714 3 22.7678571 3.53571429 23.3035714 13"></polyline>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		</a>
	</section>
</template>

<script>
export default {
	name: 'ContactFooter',
	props: ['site', 'displayLogo', 'isLandingMounted', 'currentLang'],
	methods:{
		rot13Fast(str) { 
			return str.split('').map(x => this.rot13Fast.lookup[x] || x).join('')
		},
		decryptMail(encString){
			this.rot13Fast.input  = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
			this.rot13Fast.output = 'NOPQRSTUVWXYZABCDEFGHIJKLMnopqrstuvwxyzabcdefghijklm'.split('')
			this.rot13Fast.lookup = this.rot13Fast.input.reduce((m,k,i) => Object.assign(m, {[k]: this.rot13Fast.output[i]}), {})
			var linkString = "mailto:" ;
			var addressString = this.rot13Fast(encString);
			linkString += addressString;
			document.location.href = linkString;
			return false;
		}
	}
}
</script>

<style lang="scss">
	.contact{
		text-align:center;
		margin: 2rem 0;
		@media screen and (min-width:768px){
			margin:6rem 0;
		}
		.logo{
			max-width: 120px;
			margin-bottom:2rem;
		}
		p{
			font-family:'surtSemiBold_extended', Helvetica, sans-serif;
			font-size:2rem;
			line-height:3rem;
			margin-bottom:2.3rem;
			letter-spacing:0.86px;
			max-width:900px;
			margin:auto;
			@media screen and (min-width:768px){
				font-size:3.667rem;
				line-height:4.395rem;
			}
		}
		a{
			font-family: 'surtregular', Helvetica, Arial, sans-serif;
			font-size:1.3rem;
			line-height:2.3rem;
			color:#000;
			margin-top:2rem;
			display: block;
			@media screen and (min-width:768px){
				font-size:2.267rem;
				line-height:2.867rem;
			}
		}
		svg{
			margin-left: 1rem;
		}
	}
</style>
